import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { clientContactsService } from '../api/client-contacts.service';
import { CLIENT_CONTACTS_KEYS } from './queryKeys';

export const useClientContacts = (clientId: string, options?: { enabled?: boolean }) => {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: CLIENT_CONTACTS_KEYS.byClient(orgId, clientId),
    queryFn: ({ signal }) => clientContactsService.getAll(clientId, signal),
    staleTime: 60_000,
    enabled: (options?.enabled ?? true) && !!orgId && !!clientId,
  });
};
